import Swiper from "swiper";

const MOBILE_BREAKPOINT = 1024;
const SLIDE_SCALE = 0.75;
const DESIRED_GAP = 12;

function outfitProductSlider() {
  return {
    swiper: null,

    init() {
      this.$nextTick(() => {
        this.initSlider();
      });

      this._onResize = () => this.handleResize();
      window.addEventListener("resize", this._onResize);
    },

    destroy() {
      window.removeEventListener("resize", this._onResize);
      this.destroySlider();
    },

    handleResize() {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        if (this.swiper) {
          this.swiper.params.spaceBetween = this.getSpaceBetween();
          this.swiper.update();
        } else {
          this.initSlider();
        }
      } else {
        this.destroySlider();
      }
    },

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },

    getSpaceBetween() {
      // Inactive slides use scale(0.75), which leaves empty space inside the
      // slide box. Negative spaceBetween pulls them closer without changing size.
      const slideWidthRatio =
        parseFloat(
          getComputedStyle(this.$refs.slider).getPropertyValue(
            "--outfit-slide-width"
          )
        ) / 100 || 0.55;
      const slideWidth = this.$refs.slider.offsetWidth * slideWidthRatio;
      return DESIRED_GAP - (slideWidth * (1 - SLIDE_SCALE)) / 2;
    },

    initSlider() {
      if (!this.$refs.slider || window.innerWidth >= MOBILE_BREAKPOINT) return;
      if (this.swiper) return;

      const slides = this.$refs.slider.querySelectorAll(".swiper-slide");

      this.swiper = new Swiper(this.$refs.slider, {
        loop: slides.length > 1,
        loopedSlides: slides.length,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: this.getSpaceBetween(),
      });
    },
  };
}

export default outfitProductSlider;
